import React from "react";
import { Container } from "react-bootstrap";
import Link from "components/link";
import getImagePath from "helpers/get-image-path";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation, Pagination } from "swiper";
import * as styles from "./style.mod.scss";
import RoundedImages from "./rounded-images";

const CollectionsFilterSlider = ({ data }) => {

  const collectionUrl = (handle, documentType) => documentType === "product" ? `/products/${handle}` : `/collections/${handle}`;

  const settings = {
    spaceBetween: 25,
    slidesPerView: 3.1,
    slidesPerGroup: 1,
    loop: true,
    className: "collection-slider-swiper",
    pagination: { clickable: true },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true
    },
    modules: [Pagination, Navigation, Mousewheel],
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 25,
        pagination: false,
      },
      992: {
        slidesPerView: 4.4,
        spaceBetween: 15,
      },
      1025: {
        spaceBetween: 20,
        slidesPerView: 5.3,
      },
      1270: {
        spaceBetween: 15,
        slidesPerView: 6,
      }
    },
  };

  if (data?.roundedImages) return <RoundedImages data={data} />;

  else
    return (
      <div className={styles.collectionFilterSlider} style={{ backgroundColor: data?.bgColor && data?.bgColor?.hex }}>
        <Container>
          <div className={styles.content}>
            {data?.title && <h2>{data?.title}</h2>}
            <div className={styles.sliderContainer}>
              <Swiper {...settings}>
                {data?.collectionItem?.map((thisColl, i) => (
                  <SwiperSlide key={i}>
                    <div className={styles.categoryContainer} key={i}>
                      <Link
                        to={collectionUrl(thisColl?.handle?.path, thisColl?.handle?.type)}
                      >
                        <div className={styles.prodImg}>
                          <img src={getImagePath(thisColl?.image)} alt={thisColl?.image?.alt} />
                        </div>
                        <p style={{ color: data?.coloredTextColor?.hex }} className={styles.collectionColoredTitle}>
                          {thisColl?.coloredTitle}
                        </p>
                        <p className={styles.collectionTitle}>
                          {thisColl?.title}
                        </p>
                      </Link>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </div>

            {(data?.button?.btnTitle && data?.button?.btnLink) &&
            <Link to={data?.button?.btnLink}>
              <div className={styles.cardButton}>
                <p>{data?.button?.btnTitle}</p>
              </div>
            </Link>}
          </div>
        </Container>
      </div>
    );
};

export default CollectionsFilterSlider;